import React from 'react'
import MaterialSymbol from '../material-symbol'

const AccountCircle = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="account_circle" {...props} />
))

AccountCircle.displayName = 'AccountCircle'

export default AccountCircle
